import ArrowIcon from "assets/icons/ArrowIcon";
import classnames from "classnames";
import { useState } from "react";
import { Col, Row } from "react-bootstrap";
import { AccordionHeadingType, AccordionItemType } from "types/components/Accordion";
import styles from "./styles.module.scss";
import { EnumCurrency } from "types/api/api";

interface AccordionItemProps extends AccordionItemType {
  currency?: EnumCurrency;
  headings: AccordionHeadingType[];
}

const AccordionItem = ({
  cardContent,
  currency,
  expansionContent,
  headings,
  ...rest
}: AccordionItemProps) => {
  const [expanded, setExpanded] = useState(false);

  return (
    <div
      {...rest}
      data-testid="accordion-item"
      className={classnames(styles.accordionItemWrapper, {
        [styles.accordionItemWrapperExpanded]: expanded
      })}
    >
      <div className={styles.accordionItemCard}>
        <Row className={styles.accordionItemRow}>
          {Object.values(cardContent).map((item, index) =>
            item ? (
              <Col xs={headings[index]?.xs}>
                <div data-testid="accordion-col" className="text-truncate">
                  {item}
                </div>
              </Col>
            ) : null
          )}

          <Col
            xs
            className={styles.accordionItemArrowWrapper}
            onClick={() => setExpanded(!expanded)}
            data-testid="accordion-item_arrow-icon-wrapper"
          >
            <ArrowIcon className={styles.accordionItemArrowIcon} />
          </Col>
        </Row>
      </div>

      <div className={styles.accordionItemExpansion}>
        {expansionContent.map(({ title, content }, index) => (
          <div
            className={styles.accordionItemExpansionContentWrapper}
            key={`${title}_${index}`}
            data-testid="accordion-expansion-item"
          >
            {title && <div className={styles.accordionItemExpansionTitle}>{String(title)}</div>}
            <div className={styles.accordionItemExpansionContent}>{content}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AccordionItem;
